import { Injectable } from '@angular/core';
import { StringConstants } from '@app/core/constants/string-constants';
import { AppLanguage } from '@app/shared/models/AppLanguage';
import { Device } from '@capacitor/device';
import { Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { LoadingService } from '../loading/loading.service';
import { StorageService } from '../storage/storage.service';
import { ToastService } from '../toast/toast.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  constructor(
    private translateService: TranslateService,
    private storageService: StorageService,
    private stringConstants: StringConstants,
    private toastService: ToastService,
    private loadingSvc: LoadingService,
    public platform: Platform
  ) {}
  currentLanguageKey: string = 'currentLanguage';
  public setInitialAppLanguage(): void {
    // this.setLanguageFromLocal();
    this.setDeviceDefaultLanguage();
  }
  public async setDeviceDefaultLanguage(): Promise<void> {
    // await this.loadingSvc.present(this.translateService.instant("LOADING"));
    try {
      let defaultLanguage: AppLanguage = {};

      let alreadySavedLanguage: AppLanguage = await this.getAppLanguage();

      if (
        alreadySavedLanguage &&
        alreadySavedLanguage.subTitle !== this.stringConstants.SYSTEM_LANG
      ) {
        // manual lang selected
        defaultLanguage = alreadySavedLanguage;
      } else {
        // if no lang selected or default lang selected
        const systemLanguageCode = await this.getSystemLanguageCode();

        // defaultLanguage.langDesignator = systemLanguageCode;
        defaultLanguage = {
          langDesignator: systemLanguageCode,
          subTitle: this.stringConstants.SYSTEM_LANG,
        };
        let codeFound = this.checkLanguageAvailable(systemLanguageCode);

        if (!codeFound) {
          defaultLanguage.title = 'English';
          defaultLanguage.langDesignator = 'en';
          defaultLanguage.subTitle = this.stringConstants.SYSTEM_LANG;
          this.translateService.setDefaultLang(defaultLanguage.langDesignator);
        }
      }

      this.setLanguage(defaultLanguage.langDesignator);
      await this.storageService.setJson(this.currentLanguageKey, defaultLanguage);
    } catch (error) {
      this.loadingSvc.present('THERE_IS_SOME_ISSUE_PLEASE_TRY_AGAIN');
    } finally {
      this.loadingSvc.dismiss();
    }
  }
  checkLanguageAvailable(codeToCheck: string) {
    return this.stringConstants.LAGUAGES_CODE.find((code) => code === codeToCheck);
  }
  async updateAppLanguage(newLang: AppLanguage) {
    this.setLanguage(newLang.langDesignator);
    await this.storageService.setJson(this.currentLanguageKey, newLang);
  }
  async getAppLanguage() {
    return await this.storageService.getJson(this.currentLanguageKey);
  }
  async getSystemLanguageCode() {
    const info: any = await Device.getLanguageCode();
    return info.value.substring(0, 2);
  }

  public setLanguage(lng): void {
    this.translateService.use(lng);
  }
  public async updateAppLanguageBySystem() {
    const systemLangCode = await this.getSystemLanguageCode();
    let codeFound = this.checkLanguageAvailable(systemLangCode);

    let newLang: AppLanguage = {};
    if (!codeFound) {
      this.toastService.presentToast('SYSTEM_LANGUAGE_ERROR');
      newLang.title = 'English';
      newLang.langDesignator = 'en';
      newLang.subTitle = 'English';
    } else {
      newLang.langDesignator = systemLangCode;
      newLang.title = this.translateService.instant('SYSTEM_LANGUAGE');
      newLang.subTitle = this.stringConstants.SYSTEM_LANG;
    }
    await this.updateAppLanguage(newLang);
  }
}
